
export default {
  name: 'TopbarMemosButton',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Memos'
    }
  }
};
